export type UserRouteState = {
  role: "worker" | "employer";
  emailVerified?: boolean;
  phoneVerified?: boolean;
  onboardingCompleted?: boolean;
};

export function decideNextRoute(user: UserRouteState): string {
  if (!user.emailVerified) return "/auth/email-confirmation";
  if (!user.phoneVerified) return "/auth/verification";
  if (!user.onboardingCompleted) return "/app/$role/setup";
  return "/app/$role/dashboard";
}
